import { render, staticRenderFns } from "./NavSquareBorder.vue?vue&type=template&id=24448d84&"
import script from "./NavSquareBorder.vue?vue&type=script&lang=js&"
export * from "./NavSquareBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports